import * as React from "react";

import { ReactSelectOptions } from "../../../../../types";
import { OptionLabel, RadioButtonContainer, StyledRadio } from "./RadioButtonFilter.sc";

interface IRadioButtonFilter {
    value?: string;
    options: ReactSelectOptions<string>[];
    onChange: (value: string | null) => void;
}

const RadioButtonFilter = ({ value, options, onChange }: IRadioButtonFilter) => {
    //This is because the lack of support of SSR in react-select
    const [currentValue, setCurrentValue] = React.useState<string>(value ?? "");

    const handleClick = (option: ReactSelectOptions<string>) => {
        setCurrentValue(option.value);
        onChange(option.value);
    };

    return (
        <div>
            <RadioButtonContainer>
                {options.map((option) => (
                    <div key={option.label} onClick={() => handleClick(option)}>
                        <StyledRadio id={option.value} type="radio" checked={currentValue === option.value} />
                        <OptionLabel>{option.label}</OptionLabel>
                    </div>
                ))}
            </RadioButtonContainer>
        </div>
    );
};

export default RadioButtonFilter;
